import { enumToOptions } from '@app/shared/helpers';
import { Else } from '@app/shared/models/contracts/enums/shared-enums';

export const ALTERNATIVE_STATEMENT_CONDITION_OPTIONS = enumToOptions(Else);
